module.exports = __webpack_public_path__ + "media/post-listing-block-3-image@2x.b15337f3.jpg";